"use client";
import { useTranslation } from "react-i18next";
import Button from "../../components/UI/Buttons/Button/Button";
import Welcome from "../../images/svg/welcome.svg";
import WelcomeBg from "../../images/welcomeBg.png";
import { motion, AnimatePresence } from "framer-motion";
import { useState } from "react";

const WelcomeScreen = ({
                           setScreen,
                       }: {
    setScreen: React.Dispatch<React.SetStateAction<string>>;
}) => {
    const { t } = useTranslation();
    const [visible, setVisible] = useState(true); // керує анімацією виходу

    const handleClick = () => {
        setVisible(false); // запуск виходу
        setTimeout(() => {
            setScreen("registration");
        }, 600);
    };

    return (
        <div className="relative w-full h-screen flex flex-col justify-center items-center">
            <div className="absolute inset-0">
                <img src={WelcomeBg} alt="Фон приветствия" />
            </div>

            <AnimatePresence>
                {visible && (
                    <motion.div
                        className="relative z-10 w-full h-full flex flex-col items-center"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0, y: 100 }}
                        transition={{ duration: 0.6, ease: "easeInOut" }}
                    >
                        <div className="w-full flex justify-center">
                            <img src={Welcome} alt="Картинка приветствия" className="w-full" />
                        </div>

                        <motion.div
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.6, duration: 0.6, ease: "easeOut" }}
                            className="flex flex-col gap-[32px] uppercase px-6 pt-11 pb-6 absolute bg-black/20 bottom-0 w-full items-center"
                        >
              <span className="text-[80px] font-semibold text-white text-center leading-none">
                {t("welcome.welcomeMessage")}
              </span>
                            <Button onClick={handleClick}>{t("continue")}</Button>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default WelcomeScreen;

